import { ColumnProps } from 'antd/lib/table';
import { DossierTableCellActions } from 'client/components/schema/procedures/table/DossierTableCellActions';
import { DossierTableCellTitle } from 'client/components/schema/procedures/table/DossierTableCellTitle';
import { AttachmentInfo } from 'common/dto/RequestDossierDto';
import React from 'react';
import { ReadDocumentIcon } from './ReadDocumentIcon';

export function getRequestDocumentListColumns(
  requestId: number,
  token: string,
  isAdmin?: boolean
): ColumnProps<AttachmentInfo>[] {
  return [
    {
      title: 'Domanda',
      dataIndex: 'title',
      key: 'title',
      render: (_, record) => (
        <DossierTableCellTitle
          isAdmin={isAdmin}
          type={record.type}
          name={record.data.name}
          readFlag={<ReadDocumentIcon document={record.data} />}
          actionsMobile={
            <DossierTableCellActions
              isAttachment={true}
              isFolder={false}
              requestId={requestId}
              token={token}
              attachmentId={record.data.id}
              mobileOnly
            />
          }
        />
      )
    },
    {
      title: 'Azioni',
      key: 'actions',
      responsive: ['md'],
      width: 100,
      render: (_, record) => (
        <DossierTableCellActions
          isAttachment={true}
          isFolder={false}
          requestId={requestId}
          token={token}
          attachmentId={record.data.id}
        />
      )
    }
  ];
}
